'use client';

import { c as _c } from "react/compiler-runtime";
import type { Address, ChainId } from '@morpho-org/blue-sdk';
import SectionErrorBoundary from '@/components/common/SectionErrorBoundary';
import { VaultV2YourPositionChartError } from './VaultV2YourPositionChart';
import VaultV2YourPositionChartClient from './VaultV2YourPositionChart/VaultV2YourPositionChart.client';
import { VaultV2TransactionsError } from './VaultV2YourTransactions/states';
import VaultV2YourTransactionsClient from './VaultV2YourTransactions/VaultV2YourTransactions.client';
const TITLE = 'Your transactions';
export interface VaultV2YourPositionClientProps {
  vaultAddress: Address;
  chainId: ChainId;
}
const VaultV2YourPositionClient = t0 => {
  const $ = _c(11);
  const {
    vaultAddress,
    chainId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <VaultV2YourPositionChartError />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== chainId || $[2] !== vaultAddress) {
    t2 = <SectionErrorBoundary fallback={t1}><VaultV2YourPositionChartClient vaultAddress={vaultAddress} chainId={chainId} /></SectionErrorBoundary>;
    $[1] = chainId;
    $[2] = vaultAddress;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <VaultV2TransactionsError title={TITLE} />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== chainId || $[6] !== vaultAddress) {
    t4 = <SectionErrorBoundary fallback={t3}><VaultV2YourTransactionsClient address={vaultAddress} chainId={chainId} title={TITLE} /></SectionErrorBoundary>;
    $[5] = chainId;
    $[6] = vaultAddress;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <div className="gap-lg sm:gap-xl flex flex-col">{t2}{t4}</div>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
export default VaultV2YourPositionClient;